<template>
    <div class="navbar-item mobile-top-bar">
        <span class="has-text-warning tooltip is-tooltip-bottom" data-tooltip="Credit">{{ getCurrentUserCreditAmount | formatNumber }}</span>
        <span>/</span>
        <span class="has-text-danger tooltip is-tooltip-bottom" data-tooltip="Due Amount">{{ getCurrentUserDueAmount | formatNumber }}</span>
        <span>/</span>
        <span class="has-text-primary tooltip is-tooltip-bottom" data-tooltip="Deposit" @click="openModal">{{getCurrentUserDeposit | formatNumber }}{{ getCurrentUserDepositRate }}</span>
        <span class="paypal-img" @click="openModal"><img src="@/assets/paypal.png"></span>
        <div class="modal" :class="{'is-active' : isActived }">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Transactions</p>
                    <button class="delete" aria-label="close" @click="closeModal"></button>
                </header>

                <section class="modal-card-body">
                    <p class="has-text-success" v-if="getSuccess">{{ paymentMsg }}</p>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="no-wrap">Add Deposits</label>
                        </div>
                        <div class="field-body mr-10 mbr-0">
                            <div class="field has-addons">
                                <div class="control">
                                    <input v-model="amount_yen" v-on:keyup="convertYen()" class="input" type="number"
                                           placeholder="Amount">
                                </div>
                                <p class="control">
                                    <a class="button is-static">
                                        000 ¥
                                    </a>
                                </p>
                                <div class="control">
                                    <input class="input" type="number" v-on:keyup="convertUsd()" placeholder="Amount"
                                           v-model="amount_usd">
                                </div>
                                <p class="control">
                                    <a class="button is-static">
                                        $
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div class="field-submit">
                            <div ref="paypal"></div>
                        </div>
                    </div>
                    <table class="table is-striped is-narrow is-hoverable is-fullwidth">
                        <thead>
                        <tr>
                            <th>Transaction</th>
                            <th>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colspan="2" class="has-text-centered">Coming soon...</td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="closeModal">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import PayPal from 'vue-paypal-checkout'
    import apiRates from '../../api/apiRates'

    export default {
        components: {
            PayPal
        },
        data() {
            return {
                modalStatus: false,
                amount_yen: '',
                amount_usd: '',
                paymentMsg: '',
                paypalClient: {
                    sandbox: 'ASqta9ZOOfiQLr_z4iniwYPJvsJ1Atk45zd82fTaI023ND8I9u5pBKvBi60QImFcob1V6dxfQBq7-qvY',
                    production: 'AaxhtJJA0nr5yaI-6GppVrCVqTCDWt_8sqGPio39eabV5HVKH2tqHBb5FX0up_GYaUwFMVG9oG-f1Kxu'
                }
            }
        },
        computed: {
            getCurrentUserCreditAmount() {
                return this.$store.getters.getCurrentUserCreditAmount
            },
            getCurrentUserDeposit() {
                return this.$store.getters.getUserDeposit
            },
            getCurrentUserDepositRate() {
                return this.$store.getters.getUserDepositRate == 1 ? '¥' : '$'
            },
            getCurrentUserDueAmount() {
                return this.$store.getters.getUserDueAmount
            },
            isActived() {
                return this.modalStatus
            },
            getSuccess() {
                return this.$store.getters.getPaymentData
            }
        },
        methods: {
            openModal() {
                this.modalStatus = true
            },
            closeModal() {
                this.modalStatus = false
            },
            convertYen() {
                setTimeout(function () {
                    //this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = {amount_yen: this.amount_yen}
                    apiRates
                        .convertYenRequest(query)
                        .then((response) => {
                            this.amount_usd = response.data
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }.bind(this), 1000)
            },
            convertUsd() {
                setTimeout(function () {
                    //this.$store.dispatch('changePlaceBidLoadingStatus', true)
                    const query = {amount_usd: this.amount_usd}
                    apiRates
                        .convertUsdRequest(query)
                        .then((response) => {
                            this.amount_yen = response.data
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }.bind(this), 1000)
            },
            setLoaded: function () {
                this.loaded = true;

                window.paypal
                    .Buttons({
                        createOrder: (data, actions) => {
                            if (this.amount_usd) {
                                return actions.order.create({
                                    purchase_units: [
                                        {
                                            description: 'Deposits in UNET',
                                            amount: {
                                                currency_code: "USD",
                                                value: this.amount_usd
                                            }
                                        }
                                    ]
                                });
                            }
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            if (order) {
                                this.$store.dispatch('payment', order);

                                this.amount_usd = '';
                                this.amount_yen = '';
                                this.paymentMsg = 'Payment Successful';
                                console.log(order);
                            }
                        },
                        onError: err => {
                            console.log(err);
                        }
                    })
                    .render(this.$refs.paypal);
            }
        },
        created() {
            const script = document.createElement("script");
            script.src =
                "https://www.paypal.com/sdk/js?disable-funding=credit,card&client-id=" + this.paypalClient.production;
            script.addEventListener("load", this.setLoaded);
            document.body.appendChild(script);
        }
    }
</script>

<style scoped>
    span {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/Navigation/Deposit.vue